import React, { useEffect } from 'react';
import Pressable from '../other/Pressable';

// Generate a UUID v4
const generateUUID = () => {
    return crypto.randomUUID();
};

// Duplicate boxes with offset, returns { newBoxes, newIds }
export const duplicateBoxes = (boxIds, json, offsetX = 50, offsetY = 30) => {
    const newBoxes = {};
    const newIds = [];
    
    boxIds.forEach((id) => {
        const original = json[id];
        if (!original || original.type !== 'caixa') return;
        
        const newId = generateUUID();
        newIds.push(newId);
        
        const [a, b, c, d, e, f] = original.box.transform;
        const { cordo, ...restOriginal } = original;
        newBoxes[newId] = {
            ...restOriginal,
            cordo: undefined,
            box: {
                ...original.box,
                transform: [a, b, c, d, e + offsetX, f + offsetY]
            }
        };
    });
    
    return { newBoxes, newIds };
};

function BotoUndoRedo({ undo, redo, canUndo, canRedo }) {
    return (
        <>
            <Pressable className={`boto ${!canUndo ? 'disabled' : ''}`} onClick={canUndo ? undo : null}>
                <span role="img" aria-label="undo">↩️</span>
                <div style={{
                    position: 'absolute',
                    left: 12,
                    backgroundColor: 'rgba(173, 216, 230, 0.7)',
                    fontSize: 10,
                    padding: 3,
                    borderRadius: 5,
                    color: 'rgba(0, 0, 0, 0.7)',
                }}>
                    Ctrl/Cmd + Z
                </div>
            </Pressable>
            {/* <Pressable className={`boto ${!canRedo ? 'disabled' : ''}`} onClick={canRedo ? redo : null}>
                <span role="img" aria-label="redo">↪️</span>
            </Pressable> */}
        </>
    );
}

function BotoCreateCaixa({ setJsonOutput, selectedIds, json, pz, setSelectedIds, setCaixaSelected }) {
    const createOrDuplicate = () => {
        // If boxes are selected, duplicate them
        if (selectedIds && selectedIds.length > 0) {
            const { newBoxes, newIds } = duplicateBoxes(selectedIds, json);
            
            setJsonOutput(prev => ({
                ...prev,
                ...newBoxes
            }));
            
            // Select the new boxes (deselect old ones)
            setSelectedIds(newIds);
            setCaixaSelected(-1);
            return;
        }
        
        // No selection: create a single new box in the center of the view
        const id = generateUUID();
        let transform = [1, 0, 0, 1, 100, 100];
        
        if (pz) {
            const pzTransform = pz.getTransform();
            const viewWidth = window.innerWidth;
            const viewHeight = window.innerHeight;
            const centerX = (viewWidth / 2 - pzTransform.x) / pzTransform.scale;
            const centerY = (viewHeight / 2 - pzTransform.y) / pzTransform.scale;
            transform = [1, 0, 0, 1, centerX - 50, centerY - 25];
        }
        
        setJsonOutput(prev => ({
            ...prev,
            [id]: {
                type: 'caixa',
                box: {
                    width: 100,
                    height: 50,
                    transform,
                    fill: 'white'
                },
                text: {
                    transform: [1, 0, 0, 1, 0, 0]
                }
            }
        }));
        
        // Select the new box
        setSelectedIds([id]);
        setCaixaSelected(-1);
    };

    return (
        <Pressable className="boto" onClick={createOrDuplicate} style={{ position: 'relative' }}>
            <span style={{ fontSize: 24, fontWeight: 'bold', marginLeft: 5, marginRight: 5 }}>+</span>
            <div style={{
                position: 'absolute',
                right: 2,
                bottom: 5,
                width: 14,
                height: 10,
                border: '1px solid rgba(0, 0, 0, 0.5)',
                borderRadius: 3,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
            }} />
            <div style={{
                position: 'absolute',
                left: -10,
                backgroundColor: 'rgba(173, 216, 230, 0.7)',
                fontSize: 10,
                padding: 3,
                borderRadius: 5,
                color: 'rgba(0, 0, 0, 0.7)',
            }}>
                N
            </div>
        </Pressable>
    );
}

function BotoCreateText({ json, selectedIds, setJsonOutput, pz, setSelectedIds, setCaixaSelected, pestanya }) {
    const createOrDuplicateText = () => {
        // Duplicate existing texts if selected
        if (selectedIds && selectedIds.length > 0) {
            const newTexts = {};
            const newIds = [];

            selectedIds
                .filter(id => json[id]?.type === 'text')
                .forEach(id => {
                    const original = json[id];
                    const newId = generateUUID();
                    const [a, b, c, d, e, f] = original.box.transform;

                    newTexts[newId] = {
                        ...original,
                        box: {
                            ...original.box,
                            transform: [a, b, c, d, e + 50, f + 30]
                        }
                    };

                    newIds.push(newId);
                });

            if (Object.keys(newTexts).length > 0) {
                setJsonOutput(prev => ({
                    ...prev,
                    ...newTexts
                }));

                setSelectedIds(newIds);
                setCaixaSelected(-1);
                return;
            }
        }

        const value = window.prompt('Text a mostrar', 'Text');
        if (value === null) return;

        const id = generateUUID();
        let transform = [1, 0, 0, 1, 100, 100];

        if (pz) {
            const pzTransform = pz.getTransform();
            const viewWidth = window.innerWidth;
            const viewHeight = window.innerHeight;
            const centerX = (viewWidth / 2 - pzTransform.x) / pzTransform.scale;
            const centerY = (viewHeight / 2 - pzTransform.y) / pzTransform.scale;
            transform = [1, 0, 0, 1, centerX - 100, centerY - 25];
        }

        setJsonOutput(prev => ({
            ...prev,
            [id]: {
                type: 'text',
                value: value,
                pestanya: pestanya?.toLowerCase(),
                box: {
                    width: 200,
                    height: 50,
                    transform,
                },
                text: {
                    transform: [1, 0, 0, 1, 0, 0]
                }
            }
        }));

        setSelectedIds([id]);
        setCaixaSelected(-1);
    };

    return (
        <Pressable className="boto" onClick={createOrDuplicateText} style={{ position: 'relative' }}>
            <span style={{ fontSize: 24, fontWeight: 'bold', marginLeft: 5, marginRight: 5 }}>+</span>
            <div style={{
                position: 'absolute',
                right: 5,
                bottom: 5,
                fontSize: 9,
                fontWeight: 'bold',
                color: 'rgba(0, 0, 0, 0.6)',
                fontFamily: 'serif',
                fontStyle: 'italic',
            }}>
                Abc
            </div>
            <div style={{
                position: 'absolute',
                left: -10,
                backgroundColor: 'rgba(173, 216, 230, 0.7)',
                fontSize: 10,
                padding: 3,
                borderRadius: 5,
                color: 'rgba(0, 0, 0, 0.7)',
            }}>
                T
            </div>
        </Pressable>
    );
}

export function BotoTransformModeSetter({ mode, setMode }) {
    const toggleMode = () => {
        setMode(prev => prev === 'transform' ? null : 'transform');
    };

    return (
        <Pressable 
            className={`boto ${mode === 'transform' ? 'active' : ''}`} 
            onClick={toggleMode}
            style={{
                backgroundColor: mode === 'transform' ? '#a8d0ff' : undefined,
                color: mode === 'transform' ? '#333' : undefined,
            }}
        >
            <span role="img" aria-label="transform">✥</span>
        </Pressable>
    );
}

function BotoDelete({ selectedIds, setJsonOutput, setSelectedIds, setCaixaSelected }) {
    const hasSelection = selectedIds && selectedIds.length > 0;
    
    const deleteSelected = () => {
        if (!hasSelection) return;
        
        setJsonOutput(prev => {
            const newJson = { ...prev };
            selectedIds.forEach(id => {
                delete newJson[id];
            });
            return newJson;
        });
        
        setSelectedIds([]);
        setCaixaSelected(-1);
    };

    return (
        <Pressable 
            className={`boto ${!hasSelection ? 'disabled' : ''}`} 
            onClick={hasSelection ? deleteSelected : null}
            style={!hasSelection ? {
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                cursor: 'not-allowed',
                pointerEvents: 'none'
            } : undefined}
        >
            <span role="img" aria-label="delete">🗑️</span>
            <div style={{
                position: 'absolute',
                left: -10,
                backgroundColor: 'rgba(173, 216, 230, 0.7)',
                fontSize: 10,
                padding: 3,
                borderRadius: 5,
                color: 'rgba(0, 0, 0, 0.7)',
            }}>
                ⌫
            </div>
        </Pressable>
    );
}

function BotoSelect({ submode, setSubmode }) {
    const toggleSelect = () => {
        setSubmode(prev => prev === 'select' ? null : 'select');
    };

    return (
        <Pressable 
            className={`boto ${submode === 'select' ? 'active' : ''}`} 
            onClick={toggleSelect}
            style={{
                backgroundColor: submode === 'select' ? '#a8d0ff' : undefined,
                color: submode === 'select' ? '#333' : undefined,
            }}
        >
            <span role="img" aria-label="select">⬚</span>
            <div style={{
                position: 'absolute',
                left: 40,
                backgroundColor: 'rgba(173, 216, 230, 0.7)',
                fontSize: 10,
                padding: 3,
                borderRadius: 5,
                color: 'rgba(0, 0, 0, 0.7)',
            }}>
                S
            </div>
        </Pressable>
    );
}

function BotoSnap({ snapEnabled, setSnapEnabled }) {
    const toggleSnap = () => setSnapEnabled(prev => !prev);
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    const keyLabel = isMac ? 'Option' : 'Alt';

    return (
        <Pressable
            className={`boto ${snapEnabled ? 'active' : ''}`}
            onClick={toggleSnap}
            style={{
                backgroundColor: snapEnabled ? '#a8d0ff' : undefined,
                color: snapEnabled ? '#333' : undefined,
            }}
        >
            <span role="img" aria-label="snap">🧲</span>
            <div style={{
                position: 'absolute',
                left: 12,
                backgroundColor: 'rgba(173, 216, 230, 0.7)',
                fontSize: 10,
                padding: 3,
                borderRadius: 5,
                color: 'rgba(0, 0, 0, 0.7)',
            }}>
                {keyLabel}
            </div>
        </Pressable>
    );
}

export function TransformTools({ selectedIds, json, setJsonOutput, caixaSelected, setMode, undo, redo, canUndo, canRedo, setSelectedIds, setCaixaSelected, pz, clipboard, setClipboard, submode, setSubmode, snapEnabled, setSnapEnabled, pestanya }) {
    const hasSelection = selectedIds && selectedIds.length > 0;
    
    const copySelection = () => {
        if (!hasSelection) return;
        // Store the selected boxes' data in clipboard
        const copiedData = selectedIds
            .filter(id => json[id]?.type === 'caixa')
            .map(id => ({ ...json[id] }));
        setClipboard(copiedData);
    };
    
    const pasteClipboard = () => {
        if (!clipboard || clipboard.length === 0) return;
        
        const newBoxes = {};
        const newIds = [];
        
        clipboard.forEach((original) => {
            const newId = generateUUID();
            newIds.push(newId);
            
            const [a, b, c, d, e, f] = original.box.transform;
            const { cordo, ...restOriginal } = original;
            newBoxes[newId] = {
                ...restOriginal,
                cordo: undefined,
                box: {
                    ...original.box,
                    transform: [a, b, c, d, e + 50, f + 30] // Offset pasted boxes
                }
            };
        });
        
        setJsonOutput(prev => ({ ...prev, ...newBoxes }));
        // Select the new boxes (deselect old ones)
        setSelectedIds(newIds);
        setCaixaSelected(-1);
    };
    
    const deleteSelected = () => {
        if (!hasSelection) return;
        
        setJsonOutput(prev => {
            const newJson = { ...prev };
            selectedIds.forEach(id => {
                delete newJson[id];
            });
            return newJson;
        });
        
        setSelectedIds([]);
        setCaixaSelected(-1);
    };

    // Keyboard shortcuts for copy/paste/undo/select/delete
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.defaultPrevented) return;
            // Skip if user is typing in an input
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') return;

            const modKey = e.metaKey || e.ctrlKey;
            const key = e.key.toLowerCase();

            if (modKey && key === 'c') {
                e.preventDefault();
                copySelection();
            } else if (modKey && key === 'v') {
                e.preventDefault();
                pasteClipboard();
            } else if (modKey && key === 'z' && !e.shiftKey && canUndo) {
                e.preventDefault();
                undo();
            } else if (key === 's') {
                e.preventDefault();
                setSubmode(prev => prev === 'select' ? null : 'select');
            } else if (e.key === 'Backspace' || e.key === 'Delete') {
                e.preventDefault();
                deleteSelected();
            }
        };
        
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [selectedIds, json, clipboard, canUndo, undo, setSubmode, hasSelection, submode]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Alt' && !e.repeat) {
                e.preventDefault();
                setSnapEnabled(prev => !prev);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [setSnapEnabled]);

    return (
        <>
            <Pressable className="boto" onClick={() => setMode(null)}>
                <span role="img" aria-label="back">⬅️</span>
            </Pressable>
            <BotoUndoRedo undo={undo} redo={redo} canUndo={canUndo} canRedo={canRedo} />
            <BotoSelect submode={submode} setSubmode={setSubmode} />
            <BotoSnap snapEnabled={snapEnabled} setSnapEnabled={setSnapEnabled} />
            <BotoCreateCaixa setJsonOutput={setJsonOutput} selectedIds={selectedIds} json={json} pz={pz} setSelectedIds={setSelectedIds} setCaixaSelected={setCaixaSelected} />
            <BotoCreateText json={json} selectedIds={selectedIds} setJsonOutput={setJsonOutput} pz={pz} setSelectedIds={setSelectedIds} setCaixaSelected={setCaixaSelected} pestanya={pestanya} />
            <BotoDelete selectedIds={selectedIds} setJsonOutput={setJsonOutput} setSelectedIds={setSelectedIds} setCaixaSelected={setCaixaSelected} />
        </>
    );
}
